import type React from 'react';

/**
 * Garde anti-scroll pour les grilles tactiles (photos, modèles) :
 * un pointerup tactile ne déclenche l'action que si le doigt n'a
 * quasiment pas bougé depuis le pointerdown. Sinon, c'était un scroll.
 */

const TAP_TOLERANCE_PX = 10;

let touchStart: { x: number; y: number } | null = null;

export const recordTapStart = (e: React.PointerEvent) => {
  if (e.pointerType === 'mouse') return;
  touchStart = { x: e.clientX, y: e.clientY };
};

export const isRealTap = (e: React.PointerEvent | React.MouseEvent): boolean => {
  if (!touchStart) return true; // souris ou pas de point de départ : clic normal
  const dx = e.clientX - touchStart.x;
  const dy = e.clientY - touchStart.y;
  touchStart = null;
  return Math.hypot(dx, dy) <= TAP_TOLERANCE_PX;
};